export const AMENITY_OPTIONS = [
  { value: "washing_machine", label: "Washing Machine" },
  { value: "dishwasher", label: "Dishwasher" },
  { value: "balcony", label: "Balcony" },
  { value: "elevator", label: "Elevator" },
  { value: "parking", label: "Parking" },
  { value: "storage_room", label: "Storage Room" },
  { value: "bike_room", label: "Bike Room" },
  { value: "laundry_room", label: "Laundry Room" },
  { value: "shower", label: "Shower" },
  { value: "ev_charger", label: "EV Charger" },
  { value: "security_door", label: "Security Door" },
  { value: "burglar_alarm", label: "Burglar Alarm" },
  { value: "stroller_room", label: "Stroller Room" },
  { value: "kitchenette", label: "Kitchenette" },
];
